var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_444_1134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0352 7.67578H17.0352V5.42578C17.0352 4.23231 16.5611 3.08771 15.7171 2.2438C14.8732 1.39989 13.7286 0.925781 12.5352 0.925781C11.3417 0.925781 10.1971 1.39989 9.35318 2.2438C8.50926 3.08771 8.03516 4.23231 8.03516 5.42578V7.67578H5.03516C4.63733 7.67578 4.2558 7.83382 3.9745 8.11512C3.69319 8.39643 3.53516 8.77796 3.53516 9.17578V19.6758C3.53516 20.0736 3.69319 20.4551 3.9745 20.7364C4.2558 21.0177 4.63733 21.1758 5.03516 21.1758H20.0352C20.433 21.1758 20.8145 21.0177 21.0958 20.7364C21.3771 20.4551 21.5352 20.0736 21.5352 19.6758V9.17578C21.5352 8.77796 21.3771 8.39643 21.0958 8.11512C20.8145 7.83382 20.433 7.67578 20.0352 7.67578ZM9.53516 5.42578C9.53516 4.63013 9.85123 3.86707 10.4138 3.30446C10.9764 2.74185 11.7395 2.42578 12.5352 2.42578C13.3308 2.42578 14.0939 2.74185 14.6565 3.30446C15.2191 3.86707 15.5352 4.63013 15.5352 5.42578V7.67578H9.53516V5.42578ZM20.0352 19.6758H5.03516V9.17578H20.0352V19.6758ZM13.6602 14.4258C13.6602 14.6483 13.5942 14.8658 13.4706 15.0508C13.3469 15.2358 13.1712 15.38 12.9657 15.4651C12.7601 15.5503 12.5339 15.5726 12.3157 15.5292C12.0975 15.4858 11.897 15.3786 11.7397 15.2213C11.5823 15.0639 11.4752 14.8635 11.4318 14.6453C11.3884 14.427 11.4106 14.2008 11.4958 13.9953C11.5809 13.7897 11.7251 13.614 11.9101 13.4904C12.0951 13.3668 12.3127 13.3008 12.5352 13.3008C12.8335 13.3008 13.1197 13.4193 13.3307 13.6303C13.5416 13.8413 13.6602 14.1274 13.6602 14.4258Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_444_1134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.535156 0.175781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.834578423dc9851ceef9751a31d45027.svg";
export { ForwardRef as ReactComponent };